module.exports = __webpack_public_path__ + "static/img/a037.1f22e4c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/banner/s/a037.jpg
// module id = mvGb
// module chunks = 0